import { render, staticRenderFns } from "./ScrollToComponent.vue?vue&type=template&id=330784aa"
import script from "./ScrollToComponent.vue?vue&type=script&lang=ts"
export * from "./ScrollToComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports